import {css} from "emotion";
import React from "react";

const RequiredStar = () => <span className={css`color: red;`}>*</span>;

export default RequiredStar;